module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Med.ttf?v=c2ef2f60543c04565b176e2427c68de3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Med.ttf
// module id = 662
// module chunks = 0